import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import {
    GET_CHAT_USERS_REQUEST, getChatUsersSuccess, getChatUsersFailure,
    getChatMessagesRequest,
    GET_CHAT_CONVERSATIONS_REQUEST, getChatConversationsSuccess, getChatConversationsFailure,
    START_DM_REQUEST, startDMSuccess, startDMFailure,
    CREATE_GROUP_REQUEST, createGroupSuccess, createGroupFailure,
    GET_CHAT_MESSAGES_REQUEST, getChatMessagesSuccess, getChatMessagesFailure,
    SEND_CHAT_MESSAGE_REQUEST, sendChatMessageSuccess, sendChatMessageFailure,
    //DELETE_CHAT_MESSAGE_REQUEST, deleteChatMessageSuccess, deleteChatMessageFailure,
    UPLOAD_CHAT_FILE_REQUEST, uploadChatFileSuccess, uploadChatFileFailure,
} from "../actions/chatAction";
import {
    getChatUsersApi,
    getChatConversationsApi,
    startDMApi,
    createGroupApi,
    getChatMessagesApi,
    sendChatMessageApi,
    //deleteChatMessageApi,
    uploadChatFileApi,
} from "../../utils/chatApi";

function* getChatUsersWorker(): SagaIterator {
    try {
        const res = yield call(getChatUsersApi);
        yield put(getChatUsersSuccess(res.data.data.users));
    } catch (err: any) {
        yield put(getChatUsersFailure(err?.response?.data?.message || err.message));
    }
}

function* getChatConversationsWorker(): SagaIterator {
    try {
        const res = yield call(getChatConversationsApi);
        yield put(getChatConversationsSuccess(res.data.data.conversations));
    } catch (err: any) {
        yield put(getChatConversationsFailure(err?.response?.data?.message || err.message));
    }
}

function* startDMWorker(action: any): SagaIterator {
    try {
        const res = yield call(startDMApi, action.payload.recipientId);
        const conversation = res.data.data.conversation;
        yield put(startDMSuccess(conversation));
        if (conversation?._id) {
            yield put(getChatMessagesRequest(conversation._id));
        }
    } catch (err: any) {
        yield put(startDMFailure(err?.response?.data?.message || err.message));
    }
}

function* createGroupWorker(action: any): SagaIterator {
    try {
        const { groupName, memberIds } = action.payload;
        const res = yield call(createGroupApi, groupName, memberIds);
        yield put(createGroupSuccess(res.data.data.conversation));
    } catch (err: any) {
        yield put(createGroupFailure(err?.response?.data?.message || err.message));
    }
}

function* getChatMessagesWorker(action: any): SagaIterator {
    try {
        const { conversationId, page, limit } = action.payload;
        const res = yield call(getChatMessagesApi, conversationId, page, limit);
        yield put(getChatMessagesSuccess(res.data.data.messages, conversationId, page, limit));
    } catch (err: any) {
        yield put(getChatMessagesFailure(err?.response?.data?.message || err.message));
    }
}

function* sendChatMessageWorker(action: any): SagaIterator {
    try {
        const { conversationId, text, mediaUrl } = action.payload;
        const res = yield call(sendChatMessageApi, conversationId, text, mediaUrl);
        yield put(sendChatMessageSuccess(res.data.data.message));
    } catch (err: any) {
        yield put(sendChatMessageFailure(err?.response?.data?.message || err.message));
    }
}

// function* deleteChatMessageWorker(action: any): SagaIterator {
//     try {
//         const { messageId } = action.payload;
//         yield call(deleteChatMessageApi, messageId);
//         yield put(deleteChatMessageSuccess(messageId));
//     } catch (err: any) {
//         yield put(deleteChatMessageFailure(err?.response?.data?.message || err.message));
//     }
// }

function* uploadChatFileWorker(action: any): SagaIterator {
    try {
        const { file } = action.payload;
        const res = yield call(uploadChatFileApi, file);
        yield put(uploadChatFileSuccess(res.data.data.url));
    } catch (err: any) {
        yield put(uploadChatFileFailure(err?.response?.data?.message || err.message));
    }
}

export function* watchChatSaga(): SagaIterator {
    yield takeLatest(GET_CHAT_USERS_REQUEST, getChatUsersWorker);
    yield takeLatest(GET_CHAT_CONVERSATIONS_REQUEST, getChatConversationsWorker);
    yield takeEvery(START_DM_REQUEST, startDMWorker);
    yield takeEvery(CREATE_GROUP_REQUEST, createGroupWorker);
    yield takeLatest(GET_CHAT_MESSAGES_REQUEST, getChatMessagesWorker);
    yield takeEvery(SEND_CHAT_MESSAGE_REQUEST, sendChatMessageWorker);
    //yield takeEvery(DELETE_CHAT_MESSAGE_REQUEST, deleteChatMessageWorker);
    yield takeEvery(UPLOAD_CHAT_FILE_REQUEST, uploadChatFileWorker);
}